module.exports = __webpack_public_path__ + "img/top-5-2.a4c3ac98.jpg";